export const cilWindowRestore = ["24 24","<path d='M16.5 7.172h-14.613c-0.621 0.001-1.124 0.504-1.125 1.125v13.172c0.001 0.621 0.504 1.124 1.125 1.125h14.613c0.621-0.001 1.124-0.504 1.125-1.125v-13.172c-0.001-0.621-0.504-1.124-1.125-1.125h-0zM16.125 8.672v2.12h-13.863v-2.12zM2.262 21.094v-8.802h13.863v8.802z'></path><path d='M22.125 1.5h-15c-0.621 0.001-1.124 0.504-1.125 1.125v3.047h1.5v-2.672h14.25v12.897h-2.625v1.5h3c0.621-0.001 1.124-0.504 1.125-1.125v-13.647c-0.001-0.621-0.504-1.124-1.125-1.125h-0z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-window-restore.js
// module id = null
// module chunks = 